import { useEffect, useState } from 'react'

import { printPage } from '@/lib/live'

/**
 * Print one thing from a page that shows many (the queue's READY take-away, PRD): the caller
 * hides itself with `print:hidden` while `chosen` is set and renders the chosen ticket inside
 * `PrintOnly`. The dialog opens once the ticket is in the DOM; `afterprint` lets go of it, so
 * a later Cmd+P prints the page again.
 */
export function usePrintOne<T>() {
  const [chosen, setChosen] = useState<{ value: T } | null>(null)
  useEffect(() => {
    if (!chosen) return
    printPage()
  }, [chosen])
  useEffect(() => {
    const done = () => setChosen(null)
    window.addEventListener('afterprint', done)
    return () => window.removeEventListener('afterprint', done)
  }, [])
  // A fresh box each time: printing the same ticket twice must open the dialog twice.
  return { chosen: chosen?.value, print: (value: T) => setChosen({ value }) }
}
